import React from 'react'

export default function Water({className}) {
    return (

        <svg 
        className={`${className} w-8 h-8 text-[#0085FF]`} 
        aria-hidden="true" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none"
        viewBox="0 0 24 24"
        >
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 20a8 8 0 0 0 8-8 8.1 8.1 0 0 0-2.4-5.7 8 8 0 0 0-11.2 0A8.1 8.1 0 0 0 4 12a8 8 0 0 0 8 8Z"/>
        </svg>
    )
}
